module.exports = __webpack_public_path__ + "static/ubcLogo-2f92166b8b2ba2ab173e56aab6d220a4.png";